export const ADMIN_XE_PREFIX_URL = '/admin-xe'
